import React from "react";
import DashboardLayout from "../layouts/admin_layout";
import TimeseriesChart from "./components/timeseries_chart";
import CardOne from "../../components/card_one";
import CardTwo from "../../components/card_two";
import CardThree from "../../components/card_thre";
import CardFour from "../../components/card_four";
import ChartTwo from "../../components/chart_two";
import { useSelector } from "react-redux";

export default function Dashboard() {
	const user = useSelector((st) => st.user).user;
	const name = user?.firstname || user?.name || "Admin";

	return (
		<DashboardLayout>
			{/* Welcome header */}
			<div className="mb-6 overflow-hidden rounded-2xl bg-gradient-to-r from-emerald-600 via-emerald-500 to-teal-500 px-6 py-7 shadow-sm sm:px-8">
				<h1 className="text-2xl font-bold text-white sm:text-3xl">
					Welcome back, {name} 👋
				</h1>
				<p className="mt-1 text-sm text-emerald-50">
					Here's an overview of activity across all users.
				</p>
			</div>

			{/* Stat cards */}
			<div className="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4">
				<CardOne user={user} />
				<CardTwo user={user} />
				<CardThree user={user} />
				<CardFour user={user} />
			</div>

			{/* Charts */}
			<div className="mt-5 grid grid-cols-12 gap-5">
				<TimeseriesChart />
				<ChartTwo />
			</div>
		</DashboardLayout>
	);
}
